import React from 'react';
import PropTypes from 'prop-types';

export const HeaderCellWinRatio = ({ column }) => {
    return (
        <th
            className="stats-table__header-cell stats-table__header-cell--win-ratio"
            scope="col"
        >
            <button className="stats-table__header-cell-button" disabled={true}>
                <span>{column.render('Header')}</span>
            </button>
        </th>
    );
};

HeaderCellWinRatio.propTypes = {
    column: PropTypes.object,
    keyProp: PropTypes.string
};
